module.exports = __webpack_public_path__ + "img/ia05.408e3b59.png";